import React, { useEffect, useRef } from 'react'
import { useTranslation } from 'react-i18next'

import form from '../../../form'

const ContactForm2Column = () => {
  const { t } = useTranslation()
  const wrapper = useRef(null)
  useEffect(() => {
    form(wrapper.current)
  }, [])
  return (
    <div ref={wrapper} className='grid-x grid-margin-x'>
      <label className='input-block contact-form__block mb-24 medium-3 cell'>
        <span className='contact-form__label mb-8'>{t('Company')}</span>
        <input
          className='input-field contact-form__input'
          type='text'
          name='company'
          placeholder={t('Company')}
        />
      </label>
      <div className='medium-6 cell'>
        <div className='grid-x grid-margin-x'>
          <label
            className='input-block contact-form__block mb-24 small-4 cell any-select-width'
            data-validateable-block
          >
            <span className='contact-form__label mb-8'>{t('Title')}</span>
            <select
              className='input-field contact-form__input'
              name='title'
              data-validateable-input
            >
              <option selected disabled value=''>
                &nbsp;
              </option>
              <option>{t('Mr.')}</option>
              <option>{t('Ms.')}</option>
            </select>
          </label>
          <label
            className='input-block contact-form__block mb-24 small-8 cell'
            data-validateable-block
          >
            <span className='contact-form__label mb-8'>
              {t('First Name')}
              <span>*</span>
            </span>
            <input
              className='input-field contact-form__input'
              type='text'
              name='first-name'
              placeholder={t('First Name')}
              required
              data-validateable-input
            />
            <div className='input-error'>{t('This field is required')}</div>
          </label>
        </div>
      </div>
      <label
        className='input-block contact-form__block mb-24 medium-3 cell'
        data-validateable-block
      >
        <span className='contact-form__label mb-8'>
          {t('Last Name')}
          <span>*</span>
        </span>
        <input
          className='input-field contact-form__input'
          type='text'
          name='last-name'
          placeholder={t('Last Name')}
          required
          data-validateable-input
        />
        <div className='input-error'>{t('This field is required')}</div>
      </label>
      <label
        className='input-block contact-form__block mb-24 medium-6 cell'
        data-validateable-block
      >
        <span className='contact-form__label mb-8'>
          {t('Email')}
          <span>*</span>
        </span>
        <input
          className='input-field contact-form__input'
          type='email'
          name='email'
          placeholder={t('Email')}
          data-validateable-input
          required
        />
        <div className='input-error'>{t('This field is required')}</div>
      </label>
      <label
        className='input-block contact-form__block mb-24 medium-6 cell'
        data-validateable-block
      >
        <span className='contact-form__label mb-8'>
          {t('Phone')}
          <span>*</span>
        </span>
        <input
          className='input-field contact-form__input'
          type='tel'
          name='phone'
          placeholder='+1234567890'
          pattern='[+].{10,}'
          data-validateable-input
          required
        />
        <div className='input-error'>{t('This field is required')}</div>
      </label>
      <label className='input-block contact-form__block small-12 cell mb-24'>
        <span className='contact-form__label mb-8'>{t('Message')}</span>
        <textarea
          className='input-field contact-form__input'
          name='message'
          cols='4'
          rows='4'
          maxLength='1000'
        ></textarea>
      </label>

      <label className='input-block checkbox' data-validateable-block>
        <input
          type='checkbox'
          name='accept_privacy_policy'
          className='form-checkbox checkbox__input'
          required
          data-validateable-input
        />

        <span className='checkbox__fake checkbox__fake--gold contact-form__checkbox'>
          <svg width='10' height='10' viewBox='0 0 10 10'>
            <polyline points='2,5 4,7 8,3'></polyline>
          </svg>
        </span>

        <span className='checkbox__label contact-form__label--checbox'>
          {t('Accept')}{' '}
          <a
            href='/en/privacy'
            target='_blank'
            rel='noopener noreferrer'
            style={{ color: '#bd9973' }}
          >
            {t('Privacy Policy')}
          </a>
        </span>
      </label>
    </div>
  )
}

export default ContactForm2Column
